module.exports = __webpack_public_path__ + "img/digital-chart_ar.601ed0cd.svg";